import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import styled from 'styled-components'
// reducks
import {changeEmail} from '../reducks/users/operations'
// Components
import { Layout, PrimaryButton, TextDetail } from '../components'
// Mui
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { getUserEmail } from '../reducks/users/selectors'

const EmailChange = () => {

    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    const currentEmail = getUserEmail(selector)

    const [email, setEmail] = useState('')
    const [emailConfirm, setEmailConfirm] = useState('')


    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign: 'center'}}>メールアドレス変更</h1>
            <div className='spacer-50' />

            <Wrapper>
                <TextDetail label={'現在のメールアドレス'} value={currentEmail} />
                <div className='spacer-25' />
                <TextField 
                    fullWidth={true} label={'メールアドレス'} multiline={false} required={true} rows={1} type={'email'} 
                    value={email} onChange={e=>setEmail(e.target.value)} variant='filled'
                />
                <div className='spacer-25' />
                <TextField 
                    fullWidth={true} label={'メールアドレス確認用'} multiline={false} required={true} rows={1} ttype={'email'}
                    value={emailConfirm} onChange={e=>setEmailConfirm(e.target.value)} variant='filled'
                />
            </Wrapper>

            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
                <PrimaryButton 
                    label={"メールアドレスを変更する"} 
                    operation={ () => dispatch(changeEmail(email, emailConfirm)) } 
                />
                 <div className='spacer-25' />
                <Button onClick={()=>dispatch(push('/mypage'))}>マイページへ戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    )
}

export default EmailChange

const Wrapper = styled.div`
    width: 400px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`